module.exports = __webpack_public_path__ + "img/Brand_xl_white.1740a0d3.png";